function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const COLUMN_1 = {
  links: [{
    intlLabelKey: 'developerPlatform',
    intlLinkTitleKey: 'developerPlatformLinkTitle',
    url: 'https://www.coinbase.com/developer-platform',
    intlDescriptionKey: 'developerPlatformDescription',
    intlIconAltTextKey: 'developerPlatformIconAltText',
    iconType: 'pictogram',
    iconName: 'connectNavigation'
  }, {
    intlLabelKey: 'coinbasePaySdk',
    intlLinkTitleKey: 'coinbasePaySdkLinkTitle',
    url: 'https://www.coinbase.com/developer-platform/products/onramp',
    intlDescriptionKey: 'coinbasePaySdkDescription',
    intlIconAltTextKey: 'coinbasePaySdkIconAltText',
    iconType: 'spotIcon',
    iconName: 'paySDKProduct'
  }, {
    intlLabelKey: 'base',
    intlLinkTitleKey: 'baseLinkTitle',
    url: 'https://base.org',
    intlDescriptionKey: 'baseDescription',
    intlIconAltTextKey: 'baseIconAltText',
    iconType: 'pictogram',
    iconName: 'baseLogoNavigation'
  }, {
    intlLabelKey: 'delegate',
    intlLinkTitleKey: 'delegateLinkTitle',
    url: 'https://www.coinbase.com/developer-platform/products/staking',
    intlDescriptionKey: 'delegateDescription',
    intlIconAltTextKey: 'delegateIconAltText',
    iconType: 'spotIcon',
    iconName: 'stakingProduct'
  }, {
    intlLabelKey: 'waas',
    intlLinkTitleKey: 'waasLinkTitle',
    url: 'https://www.coinbase.com/developer-platform/products/wallets',
    intlDescriptionKey: 'waasDescription',
    intlIconAltTextKey: 'waasIconAltText',
    iconType: 'spotIcon',
    iconName: 'walletAsAServiceProduct'
  }, {
    intlLabelKey: 'onchainKit',
    intlLinkTitleKey: 'onchainKitLinkTitle',
    url: 'https://onchainkit.xyz/',
    intlDescriptionKey: 'onchainKitDescription',
    intlIconAltTextKey: 'onchainKitIconAltText',
    iconType: 'pictogram',
    iconName: 'easyToUse'
  }]
};
const PRODUCT_LIST = [COLUMN_1];
const EXCLUDED_UK_LABELS = new Set(['base']);
const PRODUCT_LIST_UK = PRODUCT_LIST.map(column => _objectSpread(_objectSpread({}, column), {}, {
  links: column.links.filter(link => !EXCLUDED_UK_LABELS.has(link.intlLabelKey))
}));
export { COLUMN_1, PRODUCT_LIST, PRODUCT_LIST_UK };
//# sourceMappingURL=constants.js.map
